import { defineComponent, h, PropType } from 'vue';
import { hide_shadows, show_shadows } from '../../colours_materials_appearance';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import toggle_shadows_svg from '../../../assets/img/SVG_icons/Bottom/visualisation/toggle_shadow.svg';
import { img } from '@phi/components';
import ToggleShadowTooltip from './ToggleShadowTooltip';

export const ToggleShadowsIcon = toggle_shadows_svg;

export default defineComponent({
    props: {
        state: {
            required: true,
            type: Object as PropType<State>,
        },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        disabled() {
            return !this.state.loaded;
        },

        alt() {
            return 'Show shadows';
        },
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else if (this.state.shadows_visible)
                hide_shadows();
            else
                show_shadows();
        },
    },

    render() {
        return h(BarButton, {
            disabled: this.disabled,
            active: this.state.shadows_visible,
            selected: this.state.tut_stage === 3,
            id: 'toggle-shadow-button',
            tippy: 'top',
            onClick: this.onClick,
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(toggle_shadows_svg, this.alt),
            tooltip: ToggleShadowTooltip,
        });
    }
});
